export const theme = {
  light: {
    background: "#FFFFFF",
    foreground: "#131517",
    primary: "#4b3fff",
    primaryForeground: "#FFFFFF",
    primaryHover: "#3a2fd8",
    border: "#e1e5e9",
    card: "#FFFFFF",
    accent: "#f8f9fa",
    cardForeground: "#131517",
    mutedForeground: "#616365",
    iconFilter: "none", // Keep original purple color
    iconColor: "#4b3fff", // Original purple color
  },
  dark: {
    background: "#131517",
    foreground: "#FFFFFF",
    primary: "#4b3fff",
    primaryForeground: "#FFFFFF",
    primaryHover: "#5a4fff",
    border: "#2a2d31",
    card: "#1a1d21",
    accent: "#2a2d31",
    cardForeground: "#FFFFFF",
    mutedForeground: "#9ca3af",
    iconFilter: "none", // Keep original purple color in dark mode
    iconColor: "#4b3fff", // Original purple color
  },
  fonts: {
    sans: {
      fontFamily: "DM Sans, sans-serif",
      url: "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap",
    },
  },
  customCss: {
    // Hide Zudoku's default logout button in profile menu
    'a[href="/signout"]': {
      display: "none",
    },
  },
};
